const VideoPlayer = {
	Init() {
		VideoPlayer.VideoModal();
	},
	VideoModal() {
		/* eslint-disable no-undef */
		/* eslint-disable no-unreachable */
		/* eslint-disable no-constant-condition */
		if (window.flowplayer !== undefined && $('#modalVideoPlayer').length) {
			flowplayer.cloud.then(() => {
				const $bsModal = $('#videoModal');
				let triggerPlayer;

				const modalPlayer = flowplayer('#modalVideoPlayer');
				modalPlayer.on('fullscreenexit', e => {
					if ($bsModal.data('mobile') !== undefined && $bsModal.data('mobile') === 'true') {
						$bsModal.modal('hide');
					}
				});

				$bsModal.on('show.bs.modal', e => {
					const $trigger = $(e.relatedTarget);
					triggerPlayer = flowplayer($trigger.find('[data-player-id]')[0]);
					triggerPlayer.pause();
					const videoId = $trigger.data('video-id');
					const videoLabel = $trigger.data('label');

					if (
						$bsModal.data('flowplayer-video-id') === undefined ||
						$bsModal.data('flowplayer-video-id').indexOf(videoId) === -1
					) {
						$bsModal.data('flowplayer-video-id', videoId);
						$bsModal.attr('aria-label', videoLabel);
						modalPlayer.setSrc(videoId);
					}

					// If small viewport
					if ($(window).width() <= 768) {
						$bsModal.data('mobile', 'true');
						try {
							modalPlayer.toggleFullScreen();
						} catch (exc) {
							setTimeout(() => {
								document.location.href = $('#modalVideoPlayer video source').attr('src');
								$bsModal.modal('hide');
							}, 500);
						}
					} else {
						$bsModal.data('mobile', 'false');
					}
				});

				$bsModal.on('shown.bs.modal', e => {
					modalPlayer.play();
					modalPlayer.volume = 0.0;
					modalPlayer.muted = false;
					const volumeUp = setInterval(() => {
						if (modalPlayer.volume >= 0.8) {
							clearInterval(volumeUp);
						} else {
							modalPlayer.volume += 0.1;
						}
					}, 80);
				});

				$bsModal.on('hide.bs.modal', e => {
					const volumeDown = setInterval(() => {
						if (modalPlayer.volume <= 0.1) {
							clearInterval(volumeDown);
							modalPlayer.pause();
						} else {
							modalPlayer.volume -= 0.1;
						}
					}, 20);
					if (triggerPlayer != null) {
						triggerPlayer.play();
					}
				});
			});
		}
	}
};

export default VideoPlayer;
